import React from "react";
import { format } from 'date-fns';
import { Slide, toast } from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import {RECIPIENT_HEADER} from './constants/constants';
export const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  export const isLoggedIn = () => {
      const user = localStorage.getItem('userinfo');
      const token = localStorage.getItem('token');
      return user != null && token != null && String(token).trim().length > 0;
  }

  export const getToken = () => {
    const t = localStorage.getItem('token');
    return (t ? t :'');
  }
  let currentToast = null
  export const notifyError = (message) => {
    if (!currentToast) {
        currentToast = toast.error(message,{
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => currentToast = null,
            transition: Slide
        });
    }
  }

  export const notifyErrorInBottom = (message) => {
    toast.error(message,{
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Slide
    });
  }

  export const notifySuccess = (message,setRedirectTo) => {
    toast.success(message, {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      onClose:(typeof setRedirectTo !== 'undefined'? ()=>{setRedirectTo(true)}:''),
      transition: Slide,
      });
  }

  export const notifyInfo = (message) => {
    toast.success(message, {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Slide,
      });
  }

  export const refreshLocalStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userinfo');
  } 

  export const getFirstLetter = (name) => {
    return (name.length ? name.slice(0,1) : 'N/A');      
  }

  export const exportCampaignToCSV = (campaignData) => {
    const headers = [
      "Campaign Name", 
      "Created By",
      "Created Date",
      "Mail Account", 
      "Recipients",
      "Sent",
      "Leads",
      "Replies",
      "Opens",
      "Bounces"
    ];
    // Convert data to CSV format
    const csvRows = [];
      
    csvRows.push(headers.join(",")); // Add headers
  
    campaignData.forEach((row) => {
      const filteredRow = [];
        
      filteredRow.push(row.name);
      filteredRow.push(row?.created_by_user?.name);
      filteredRow.push(format(row.created_at, 'MM/dd/yyyy'));
      filteredRow.push(row?.assigned_to_user?.email);
      filteredRow.push(row.recipients_count);
      filteredRow.push(row.total_email_event_counts?.sent);
      filteredRow.push(row.total_email_event_counts?.lead);
      filteredRow.push(row.total_email_event_counts?.reply);
      filteredRow.push(row.total_email_event_counts?.open);
      filteredRow.push(row.total_email_event_counts?.bounce);
      csvRows.push(filteredRow.join(","));
    });
  
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a download link and click it programmatically
    const link = document.createElement("a");
    link.href = url;
    link.download = "campaigns_"+(uuidv4())+".csv";
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);
  }

  export const exportRecipientsToCSV = (recipientData) => {
    const headers = [];
    recipientData.display_keys.forEach((row)=>{
      if(typeof RECIPIENT_HEADER[row] !== 'undefined'){
        headers.push(RECIPIENT_HEADER[row]);
      } else {
        headers.push(row);
      }
    });

    // Convert data to CSV format
    const csvRows = [];
      
    csvRows.push(headers.join(",")); // Add headers
  
    (recipientData.contacts).forEach((row) => {
      const filteredRow = [];
      recipientData.display_keys.forEach((key)=>{
        if(key === 'created_at' && row[key] !== ''){
          filteredRow.push(format(row[key], 'MMM d yyyy'));
        } else if(key === 'latest_sent_at'){
          if(row[key] !== ''){
            filteredRow.push(format(row[key], 'MMM d yyyy h:m:s a'));
          } else {
            filteredRow.push("Not Sent");
          }
        } else {
          filteredRow.push(row[key]);
        }
        
      });  
      csvRows.push(filteredRow.join(","));
    });
  
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a download link and click it programmatically
    const link = document.createElement("a");
    link.href = url;
    link.download = "recipients_"+(uuidv4())+".csv";
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);
  }

  export const exportLeadsToCSV = (leadData) => {
    const headers = [
      "Email",
      "Campaign",
      "Assigned to", 
      "Lead Date"
    ];
    // Convert data to CSV format
    const csvRows = [];

    csvRows.push(headers.join(",")); // Add headers
  
    leadData.forEach((row) => {
      const filteredRow = [];
        
      filteredRow.push(row.email);
      filteredRow.push(row.campaign_name);
      filteredRow.push(row.assigned_to_name);
      filteredRow.push(format(row.created_at, 'MM/dd/yyyy'));
    
      csvRows.push(filteredRow.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a download link and click it programmatically
    const link = document.createElement("a");
    link.href = url;
    link.download = "leads_"+(uuidv4())+".csv";
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);
  }

  export const exportUnsubscribersToCSV = (data,setExportLoader) => {
    setExportLoader(true);
    const headers = [
      "Email",
      "Domains",
      "Unsubscribe Date",
    ];
    // Convert data to CSV format
    const csvRows = [];

    csvRows.push(headers.join(",")); // Add headers
  
    data.forEach((row) => {
      const filteredRow = [];
      
      const domainNames = (row?.unsubscribes).map(item => item.domain).join('; ');
      filteredRow.push(row.email);
      filteredRow.push(domainNames);
      filteredRow.push(format(row.updated_at, 'MMM dd yyyy hh:mm a'));
    
      csvRows.push(filteredRow.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a download link and click it programmatically
    const link = document.createElement("a");
    link.href = url;
    link.download = "unsubscribers_"+(uuidv4())+".csv";
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);
    setExportLoader(false);
  }

  export const exportCampaignRecipientsReport = (data,name="report") => {
    const headers = [
      "Email",
      "Last Sent On",
      "Opens", 
      "Clicks",
      "Replies",
      "Is Bounced",
      "Is Lead"
    ];
    // Convert data to CSV format
    const csvRows = [];

    csvRows.push(headers.join(",")); // Add headers
  
    Object.keys(data).forEach((email,key) => {
      const filteredRow = [];
        
      filteredRow.push(email);
      filteredRow.push(format(data[email].last_sent_on, 'MM/dd/yyyy hh:mm:ss aaa'));
      filteredRow.push(data[email]?.events?.open);
      filteredRow.push(data[email]?.events?.click);
      filteredRow.push(data[email]?.events?.reply);
      filteredRow.push(data[email]?.events?.bounce);
      filteredRow.push(data[email]?.events?.lead);
    
      csvRows.push(filteredRow.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a download link and click it programmatically
    const link = document.createElement("a");
    link.href = url;
    link.download = name+"_"+(uuidv4())+".csv";
    link.click();

    // Clean up the URL object
    URL.revokeObjectURL(url);
  }